@if (memoryService.bookingDataInitialized || isProfileRoute) {
  <router-outlet/>
}
